var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section home"},[_c('div',{staticClass:"container"},[_c('Wizard')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }